//import EfShopingCart from '@elem/ui/ef-shoping-cart';
import EcoCart from 'eco-design/elements/eco-cart';

export default function GloCart({ systemTimestamp, iconUrl }: { systemTimestamp: number; iconUrl?: string }) {
    return <>{<EcoCart systemTimestamp={systemTimestamp} iconUrl={iconUrl} />}</>;
}
